
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mechanic/[city]",
      function () {
        return require("private-next-pages/mechanic/[city]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mechanic/[city]"])
      });
    }
  